import { Component, OnInit, Input, OnChanges, Output, EventEmitter } from '@angular/core';
import { ReportType } from '../../models/metric-cards.model';
import { NgClass } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DecodeHtmlStringPipe } from '../../pipes/decode-htm-string.pipe';
import { DecodeHtmlString } from '../../../../../core/src/app/feature-modules/deice/pipes/html-decode.pipe';

export enum TaxiTimeIndicator {
  none = 0,
  red,
  orange,
  purple,
  yellow,
}

export class TaxiTimes {
  id: string;
  label: string;
  width: string;
  height: string;
  isChecked?: boolean;
  taxiTimeId: string;

  value: number | string;
  domesticError: boolean;
  taxiTimeIndicator?: TaxiTimeIndicator;

  showInternational: boolean;
  internationalValue: number | string;
  internationIndicator?: TaxiTimeIndicator;
  internationalError: boolean;
  hideCheckBox: boolean;
  reportType: ReportType;
  showLabelTop: boolean;
}

export class TaxiOutTime {
  list: TaxiTimes[];
  constructor() {
    this.list = new Array<TaxiTimes>();
  }
}

@Component({
    selector: 'emt-taxi-time',
    templateUrl: './taxi-time.component.html',
    styleUrls: ['./taxi-time.component.scss'],
    imports: [
        NgClass,
        FormsModule,
        DecodeHtmlStringPipe,
        DecodeHtmlString,
    ],
})
export class TaxiTimeComponent implements OnInit, OnChanges {
  @Input() data: TaxiTimes;
  @Input() isCondensedMode: boolean;
  @Output() taxiOutId: EventEmitter<any> = new EventEmitter();

  public taxiTimeIndicatorClass: string;
  public internationalIndicatorClass: string;

  constructor() {}

  ngOnInit() {}

  ngOnChanges() {
    this.internationalIndicatorClass = this.data ? this.getIndicatorClass(this.data.internationIndicator) : undefined;
    this.taxiTimeIndicatorClass = this.data ? this.getIndicatorClass(this.data.taxiTimeIndicator) : undefined;
  }

  public getInternationalIndicatorClass() {
    return this.data ? this.getIndicatorClass(this.data.internationIndicator) : undefined;
  }

  public getTaxiTimeIndicatorClass() {}

  onCheckboxChange(event) {
    let taxiOutObject = {};
    taxiOutObject['id'] = this.data.taxiTimeId;
    taxiOutObject['status'] = event.target.checked;
    this.taxiOutId.emit(taxiOutObject);
  }

  private getIndicatorClass(indicator: TaxiTimeIndicator) {
    switch (indicator) {
      case TaxiTimeIndicator.orange:
        return 'orange-border';
      case TaxiTimeIndicator.red:
        return 'red-border';
      case TaxiTimeIndicator.purple:
        return 'purple-border';
      case TaxiTimeIndicator.yellow:
        return 'yellow-border';
      case TaxiTimeIndicator.none:
      default:
        return '';
    }
  }
}
